/* eslint-disable no-mixed-operators */
/* Motor del Reporte PDF de avance de obra.
   Cada página es render(ctx, W, H, R, P) sobre un canvas A4 (1240 × 1754 a tamaño real).
   R = datos del reporte (fotos reales, IA, clima, reportabilidad y lo que edita el cliente). P = número de página. */
import { img, cover, rr, text, dot, clamp, fdate, num, pickN, MESES, setEstilo } from '../socialStudio/engine';
import { iconoClima } from './reporte.api';

export const A4 = [1240, 1754];
const INK = '#101512', MUT = '#5e6b64', LINE = '#e3e8e5', CARD = '#f3f6f4';

// ───── utilidades ─────
function shadeHex(hex, f) {
  const n = parseInt(hex.replace('#', ''), 16);
  const ch = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => Math.round(f < 0 ? c * (1 + f) : c + (255 - c) * f));
  return '#' + ch.map((c) => c.toString(16).padStart(2, '0')).join('');
}
const dias = (a, b) => Math.round((new Date(b) - new Date(a)) / 864e5);
const addDias = (iso, n) => { const d = new Date(iso + 'T12:00:00'); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const corto = (iso) => { const [, m, d] = iso.split('-').map(Number); return `${d}/${m}`; };
const mesCorto = (iso) => { const [y, m] = iso.split('-').map(Number); return `${MESES[m - 1]} ${String(y).slice(2)}`; };
// HH:mm de un instante en la zona de la obra (la del navegador si no se conoce).
export const horaFoto = (iso, timeZone) => {
  const d = new Date(iso);
  if (!iso || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: timeZone || undefined });
};

function drawLogo(ctx, R, x, y, maxW, maxH, color = INK) {
  const lg = R.logoSrc ? img(R.logoSrc) : null;
  if (lg) {
    const r = lg.naturalWidth / lg.naturalHeight, w = Math.min(maxW, maxH * r), h = w / r;
    ctx.drawImage(lg, x, y + (maxH - h) / 2, w, h);
    return w;
  }
  text(ctx, R.cliente, x, y + maxH * 0.18, { size: maxH * 0.6, color, weight: 700 });
  return 0;
}

function marco(ctx, W, H, R, P, kicker, titulo) {
  const s = W / 1240;
  ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = R.accent; ctx.fillRect(0, 0, W, 12 * s);
  if (kicker) text(ctx, kicker.toUpperCase(), 80 * s, 72 * s, { size: 22 * s, color: R.accentDark, ls: 4 * s, weight: 700 });
  if (titulo) text(ctx, titulo, 80 * s, 108 * s, { size: 52 * s, color: INK, maxW: W - 160 * s });
  ctx.fillStyle = LINE; ctx.fillRect(80 * s, H - 112 * s, W - 160 * s, 2 * s);
  drawLogo(ctx, R, 80 * s, H - 92 * s, 180 * s, 46 * s);
  text(ctx, `${R.obra} · Reporte de avance`, W / 2, H - 80 * s, { size: 20 * s, color: MUT, align: 'center', weight: 500 });
  text(ctx, `Página ${P.n} de ${P.total}`, W - 80 * s, H - 80 * s, { size: 20 * s, color: MUT, align: 'right', weight: 600 });
}

function kpi(ctx, s, x, y, w, h, valor, label, R, destacado) {
  rr(ctx, x, y, w, h, 20 * s); ctx.fillStyle = destacado ? R.accent : CARD; ctx.fill();
  text(ctx, valor, x + 30 * s, y + 28 * s, { size: 60 * s, color: destacado ? '#06100b' : INK });
  text(ctx, label, x + 30 * s, y + h - 62 * s, { size: 22 * s, color: destacado ? '#06100b' : MUT, weight: 500, maxW: w - 50 * s });
}

function barras(ctx, s, x, y, w, h, vals, labels, color, opt = {}) {
  const max = Math.max(1, opt.max || 0, ...vals), n = Math.max(1, vals.length), slot = w / n, bw = slot * (opt.ancho || 0.62);
  ctx.strokeStyle = LINE; ctx.lineWidth = 2 * s;
  for (let k = 0; k <= 4; k++) { const yy = y + h - h * k / 4; ctx.beginPath(); ctx.moveTo(x, yy); ctx.lineTo(x + w, yy); ctx.stroke(); }
  const cada = Math.ceil(n / (opt.maxLabels || 16));
  vals.forEach((v, i) => {
    const bh = h * v / max, bx = x + i * slot + (slot - bw) / 2;
    rr(ctx, bx, y + h - Math.max(bh, 3 * s), bw, Math.max(bh, 3 * s), Math.min(8 * s, bw / 3)); ctx.fillStyle = typeof color === 'function' ? color(v, i) : color; ctx.fill();
    if (opt.valores !== false && v > 0 && n <= 20) text(ctx, String(Math.round(v)), bx + bw / 2, y + h - bh - 30 * s, { size: 19 * s, align: 'center', color: INK, weight: 600 });
    if (labels[i] && i % cada === 0) text(ctx, labels[i], bx + bw / 2, y + h + 12 * s, { size: 17 * s, align: 'center', color: MUT, weight: 500 });
  });
}

function dona(ctx, s, cx, cy, r, pct, color, label) {
  ctx.lineCap = 'round';
  ctx.lineWidth = r * 0.22; ctx.strokeStyle = CARD; ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();
  ctx.strokeStyle = color; ctx.beginPath(); ctx.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * clamp(pct / 100)); ctx.stroke();
  ctx.lineCap = 'butt';
  text(ctx, Math.round(pct) + '%', cx, cy - r * 0.32, { size: r * 0.5, align: 'center', color: INK });
  if (label) text(ctx, label, cx, cy + r * 0.24, { size: r * 0.15, align: 'center', color: MUT, weight: 500, maxW: r * 1.4 });
}

function foto(ctx, s, f, x, y, w, h, R, etiqueta) {
  rr(ctx, x, y, w, h, 16 * s); ctx.save(); ctx.clip(); cover(ctx, f.src, x, y, w, h); ctx.restore();
  if (etiqueta) {
    ctx.font = `700 ${Math.round(20 * s)}px Poppins, sans-serif`;
    const tw = ctx.measureText(etiqueta).width + 28 * s;
    rr(ctx, x + 16 * s, y + 16 * s, tw, 40 * s, 20 * s); ctx.fillStyle = 'rgba(0,0,0,.6)'; ctx.fill();
    text(ctx, etiqueta, x + 30 * s, y + 24 * s, { size: 20 * s, color: '#fff', weight: 700 });
  }
}

// ───── datos derivados (avance estimado por etapas, resumen de IA, clima, reportabilidad) ─────
export const ETAPAS_BASE = [
  ['Obrador y movimiento de suelo', 0, 0.08], ['Fundaciones', 0.05, 0.18], ['Estructura', 0.15, 0.5],
  ['Mampostería y cerramientos', 0.4, 0.7], ['Instalaciones', 0.5, 0.85], ['Terminaciones', 0.7, 0.97], ['Exteriores y entrega', 0.92, 1],
];

export function etapasSugeridas(inicio, entrega, hoy) {
  const total = Math.max(30, dias(inicio, entrega)), trans = clamp(dias(inicio, hoy) / total);
  return ETAPAS_BASE.map(([nombre, a, b]) => ({
    nombre, inicio: addDias(inicio, Math.round(total * a)), fin: addDias(inicio, Math.round(total * b)),
    pct: Math.round(clamp((trans - a) / (b - a)) * 20) * 5,
  }));
}

export function avanceGeneral(etapas) {
  let tot = 0, acc = 0;
  etapas.forEach((e) => { const d = Math.max(1, dias(e.inicio, e.fin)); tot += d; acc += d * clamp((Number(e.pct) || 0) / 100); });
  return tot ? Math.round(acc / tot * 100) : 0;
}

export function resumenIA(ia) {
  if (!ia || !ia.dias || !ia.dias.length) return null;
  const act = ia.dias.filter((d) => d.max > 0);
  if (!act.length) return null;
  const prom = act.reduce((a, b) => a + b.max, 0) / act.length;
  const pico = act.reduce((a, b) => (b.max > a.max ? b : a));
  const pers = act.reduce((a, b) => a + b.max, 0), casco = act.reduce((a, b) => a + b.casco, 0);
  const ini = act.filter((d) => d.primera).map((d) => d.primera).sort();
  const fin = act.filter((d) => d.ultima).map((d) => d.ultima).sort();
  return { act, prom, pico, pctCasco: pers ? Math.round(casco / pers * 100) : null, horaIni: ini[Math.floor(ini.length / 2)], horaFin: fin[Math.floor(fin.length / 2)], diasExc: act.filter((d) => d.excavadoras > 0).length };
}

export function resumenClima(clima) {
  if (!clima || !clima.dias || !clima.dias.length) return null;
  const d = clima.dias.slice(-30);
  const media = d.reduce((a, b) => a + (b.tmax + b.tmin) / 2, 0) / d.length;
  const lluvia = d.filter((x) => x.lluvia >= 1);
  return { d, media, max: d.reduce((a, b) => (b.tmax > a.tmax ? b : a)), min: d.reduce((a, b) => (b.tmin < a.tmin ? b : a)), diasLluvia: lluvia.length, mm: d.reduce((a, b) => a + b.lluvia, 0), aprox: clima.aprox };
}

export function resumenRep(rep) {
  if (!rep || !rep.dias || !rep.dias.length) return null;
  const d = rep.dias, con = d.filter((x) => x.count > 0);
  const ult = d.reduce((a, b) => (b.ultima && (!a || b.ultima > a) ? b.ultima : a), null);
  return { d, pct: Math.round(con.length / d.length * 100), total: d.reduce((a, b) => a + b.count, 0), prom: con.length ? con.reduce((a, b) => a + b.count, 0) / con.length : 0, ultima: ult };
}

// Texto ejecutivo armado con los datos (el cliente lo puede editar).
export function redactarResumen(R) {
  const etapaActual = R.etapas.find((e) => e.pct > 0 && e.pct < 100) || R.etapas.slice().reverse().find((e) => e.pct >= 100) || R.etapas[0];
  const p = [];
  p.push(`Al ${fdate(R.hoyFecha, true)}, ${R.obra} lleva ${num(R.dias)} días de obra y un avance general estimado del ${R.avance}%. La etapa en curso es ${etapaActual.nombre.toLowerCase()}, con un ${etapaActual.pct}% de avance.`);
  if (R.iaRes) p.push(`En las últimas semanas trabajaron en promedio ${num(R.iaRes.prom)} personas por día en la obra, con un pico de ${R.iaRes.pico.max} el ${fdate(R.iaRes.pico.fecha, true)}. La jornada arrancó en general a las ${R.iaRes.horaIni || '-'} y terminó a las ${R.iaRes.horaFin || '-'}.`);
  if (R.climaRes) p.push(R.climaRes.diasLluvia ? `El clima del último mes tuvo ${R.climaRes.diasLluvia} días de lluvia (${num(R.climaRes.mm)} mm en total) y una temperatura media de ${Math.round(R.climaRes.media)}°.` : `El último mes no tuvo días de lluvia significativa, con una temperatura media de ${Math.round(R.climaRes.media)}°, lo que permitió trabajar sin interrupciones por clima.`);
  if (R.repRes) p.push(`La cámara de obra registró imágenes el ${R.repRes.pct}% de los días del período, con un promedio de ${num(R.repRes.prom)} fotos diarias.`);
  p.push('Todas las imágenes de este reporte fueron tomadas por la cámara Lisual instalada en la obra.');
  return p.join('\n\n');
}

// ───── páginas ─────
const PAGINAS = {
  portada(ctx, W, H, R) {
    const s = W / 1240, hh = H * 0.6;
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
    cover(ctx, R.heroItem.src, 0, 0, W, hh, 1.02);
    const g = ctx.createLinearGradient(0, 0, 0, 260 * s); g.addColorStop(0, 'rgba(0,0,0,.45)'); g.addColorStop(1, 'rgba(0,0,0,0)'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, 260 * s);
    const lg = R.logoSrc ? img(R.logoSrc) : null;
    if (lg) { const r = lg.naturalWidth / lg.naturalHeight, w = Math.min(320 * s, 96 * s * r), h = w / r; rr(ctx, 70 * s, 70 * s, w + 48 * s, h + 36 * s, 22 * s); ctx.fillStyle = 'rgba(255,255,255,.95)'; ctx.fill(); ctx.drawImage(lg, 94 * s, 88 * s, w, h); }
    else text(ctx, R.cliente.toUpperCase(), 80 * s, 90 * s, { size: 30 * s, color: '#fff', weight: 700, ls: 3 * s, shadow: 1 });
    ctx.fillStyle = R.accent; ctx.fillRect(0, hh, W, 16 * s);
    const y = hh + 80 * s;
    text(ctx, (R.titulo || 'Reporte de avance de obra').toUpperCase(), 80 * s, y, { size: 26 * s, color: R.accentDark, ls: 5 * s, weight: 700, maxW: W - 160 * s });
    const th = text(ctx, R.obra, 80 * s, y + 46 * s, { size: 92 * s, color: INK, maxW: W - 160 * s, lh: 1.05 });
    text(ctx, R.subtitulo, 80 * s, y + 66 * s + th, { size: 30 * s, color: MUT, weight: 500, maxW: W - 160 * s });
    const ky = H - 330 * s, kw = (W - 160 * s - 40 * s) / 3;
    kpi(ctx, s, 80 * s, ky, kw, 170 * s, R.avance + '%', 'avance general estimado', R, true);
    kpi(ctx, s, 100 * s + kw, ky, kw, 170 * s, num(R.dias), 'días de obra', R);
    kpi(ctx, s, 120 * s + kw * 2, ky, kw, 170 * s, '+' + num(R.fotos), 'fotos registradas', R);
    text(ctx, `Período: ${fdate(R.inicio, true)} al ${fdate(R.hoyFecha, true)}`, 80 * s, H - 110 * s, { size: 22 * s, color: MUT, weight: 500 });
    text(ctx, `Emitido el ${fdate(R.hoyFecha, true)}`, W - 80 * s, H - 110 * s, { size: 22 * s, color: MUT, weight: 500, align: 'right' });
  },

  resumen(ctx, W, H, R, P) {
    const s = W / 1240;
    marco(ctx, W, H, R, P, P.kicker, 'Resumen ejecutivo');
    const kw = (W - 160 * s - 40 * s) / 3, kh = 170 * s, y0 = 210 * s;
    const ks = [[R.avance + '%', 'avance general estimado', true], [num(R.dias), 'días de obra'], ['+' + num(R.fotos), 'fotos registradas'],
      [R.iaRes ? num(R.iaRes.prom) : '—', R.iaRes ? 'personas por día (promedio)' : 'personas por día (sin IA)'],
      [R.climaRes ? String(R.climaRes.diasLluvia) : '—', 'días de lluvia en el mes'], [R.repRes ? R.repRes.pct + '%' : '—', 'días con registro de cámara']];
    ks.forEach(([v, l, d], i) => kpi(ctx, s, 80 * s + (i % 3) * (kw + 20 * s), y0 + Math.floor(i / 3) * (kh + 20 * s), kw, kh, v, l, R, d));
    let y = y0 + kh * 2 + 80 * s;
    String(R.resumen || '').split(/\n+/).filter(Boolean).forEach((par) => {
      if (y > H - 640 * s) return;
      y += text(ctx, par, 80 * s, y, { size: 27 * s, color: INK, weight: 400, maxW: W - 160 * s, lh: 1.5 }) + 22 * s;
    });
    const fy = H - 560 * s, fw = (W - 160 * s - 30 * s) / 2;
    foto(ctx, s, R.hist[0], 80 * s, fy, fw, 400 * s, R, 'INICIO · ' + fdate(R.hist[0].fecha).toUpperCase());
    foto(ctx, s, R.heroItem, 110 * s + fw, fy, fw, 400 * s, R, 'HOY · ' + fdate(R.hoyFecha).toUpperCase());
  },

  etapas(ctx, W, H, R, P) {
    const s = W / 1240;
    marco(ctx, W, H, R, P, P.kicker, 'Grado de avance por etapa');
    dona(ctx, s, 300 * s, 470 * s, 190 * s, R.avance, R.accent, 'avance general');
    text(ctx, 'El avance general pondera cada etapa por su duración.', 560 * s, 340 * s, { size: 26 * s, color: MUT, weight: 400, maxW: W - 640 * s, lh: 1.4 });
    const enCurso = R.etapas.filter((e) => e.pct > 0 && e.pct < 100).length, completas = R.etapas.filter((e) => e.pct >= 100).length;
    text(ctx, `${completas} etapas completas`, 560 * s, 470 * s, { size: 36 * s, color: INK });
    text(ctx, `${enCurso} en curso · ${R.etapas.length - completas - enCurso} pendientes`, 560 * s, 525 * s, { size: 28 * s, color: MUT, weight: 500 });
    let y = 720 * s;
    const paso = Math.min(128, 760 / Math.max(1, R.etapas.length)) * s;
    R.etapas.forEach((e) => {
      const pct = clamp((Number(e.pct) || 0) / 100), estado = pct >= 1 ? 'Completa' : pct > 0 ? 'En curso' : 'Pendiente';
      text(ctx, e.nombre, 80 * s, y, { size: 30 * s, color: INK, weight: 600, maxW: 640 * s });
      text(ctx, `${Math.round(pct * 100)}%`, W - 80 * s, y, { size: 30 * s, color: INK, align: 'right' });
      text(ctx, `${estado} · ${corto(e.inicio)} → ${corto(e.fin)}`, 80 * s, y + 42 * s, { size: 21 * s, color: MUT, weight: 500 });
      rr(ctx, 80 * s, y + 82 * s, W - 160 * s, 18 * s, 9 * s); ctx.fillStyle = CARD; ctx.fill();
      if (pct > 0) { rr(ctx, 80 * s, y + 82 * s, Math.max(18 * s, (W - 160 * s) * pct), 18 * s, 9 * s); ctx.fillStyle = pct >= 1 ? R.accentDark : R.accent; ctx.fill(); }
      y += paso;
    });
    text(ctx, 'Avance estimado según el cronograma; la empresa puede ajustarlo en cada reporte.', 80 * s, H - 170 * s, { size: 21 * s, color: MUT, weight: 400, maxW: W - 160 * s });
  },

  gantt(ctx, W, H, R, P) {
    const s = W / 1240;
    marco(ctx, W, H, R, P, P.kicker, 'Diagrama de Gantt');
    const ini = R.etapas.reduce((a, e) => (e.inicio < a ? e.inicio : a), R.etapas[0].inicio);
    const fin = R.etapas.reduce((a, e) => (e.fin > a ? e.fin : a), R.etapas[0].fin);
    const total = Math.max(1, dias(ini, fin)), x0 = 400 * s, x1 = W - 80 * s, wx = (iso) => x0 + (x1 - x0) * clamp(dias(ini, iso) / total);
    const top = 260 * s, rowH = Math.min(150, 1000 / Math.max(1, R.etapas.length)) * s;
    // meses
    const d = new Date(ini + 'T12:00:00'); d.setDate(1);
    let k = 0; const nMeses = Math.ceil(total / 30.4) + 1, cada = Math.ceil(nMeses / 12);
    while (d.toISOString().slice(0, 10) <= fin && k < 80) {
      const iso = d.toISOString().slice(0, 10), x = wx(iso < ini ? ini : iso);
      ctx.fillStyle = LINE; ctx.fillRect(x, top - 10 * s, 2 * s, rowH * R.etapas.length + 20 * s);
      if (k % cada === 0) text(ctx, mesCorto(iso), x + 6 * s, top - 50 * s, { size: 18 * s, color: MUT, weight: 600 });
      d.setMonth(d.getMonth() + 1); k++;
    }
    R.etapas.forEach((e, i) => {
      const y = top + i * rowH;
      if (i % 2 === 0) { ctx.fillStyle = '#f8faf9'; ctx.fillRect(80 * s, y, W - 160 * s, rowH); }
      text(ctx, e.nombre, 96 * s, y + 30 * s, { size: 24 * s, color: INK, weight: 600, maxW: 290 * s, lh: 1.15 });
      const bx = wx(e.inicio), bw = Math.max(10 * s, wx(e.fin) - bx), by = y + 38 * s, bh = 44 * s;
      rr(ctx, bx, by, bw, bh, 10 * s); ctx.fillStyle = shadeHex(R.accent, 0.72); ctx.fill();
      const pct = clamp((Number(e.pct) || 0) / 100);
      if (pct > 0) { rr(ctx, bx, by, Math.max(10 * s, bw * pct), bh, 10 * s); ctx.fillStyle = R.accent; ctx.fill(); }
      if (bw > 70 * s) text(ctx, Math.round(pct * 100) + '%', bx + bw / 2, by + 8 * s, { size: 20 * s, align: 'center', color: '#06100b', weight: 700 });
    });
    const xh = wx(R.hoyFecha), yb = top + rowH * R.etapas.length;
    ctx.fillStyle = '#d33a2c'; ctx.fillRect(xh - 2 * s, top - 20 * s, 4 * s, yb - top + 40 * s);
    rr(ctx, xh - 46 * s, yb + 24 * s, 92 * s, 40 * s, 20 * s); ctx.fill();
    text(ctx, 'HOY', xh, yb + 32 * s, { size: 20 * s, align: 'center', color: '#fff', weight: 700 });
    const ly = yb + 130 * s;
    [[shadeHex(R.accent, 0.72), 'Planificado'], [R.accent, 'Ejecutado'], ['#d33a2c', 'Fecha de hoy']].forEach(([c, l], i) => {
      rr(ctx, 80 * s + i * 300 * s, ly, 40 * s, 24 * s, 6 * s); ctx.fillStyle = c; ctx.fill();
      text(ctx, l, 134 * s + i * 300 * s, ly - 2 * s, { size: 22 * s, color: MUT, weight: 500 });
    });
    text(ctx, `Inicio: ${fdate(ini, true)} · Entrega estimada: ${fdate(R.entrega, true)} · Faltan ${num(Math.max(0, dias(R.hoyFecha, R.entrega)))} días`, 80 * s, ly + 70 * s, { size: 24 * s, color: INK, weight: 600, maxW: W - 160 * s });
  },

  comparacion(ctx, W, H, R, P) {
    const s = W / 1240;
    marco(ctx, W, H, R, P, P.kicker, 'Del primer día a hoy');
    const fh = 560 * s;
    foto(ctx, s, R.hist[0], 80 * s, 210 * s, W - 160 * s, fh, R, `INICIO · ${fdate(R.hist[0].fecha, true).toUpperCase()}`);
    foto(ctx, s, R.heroItem, 80 * s, 230 * s + fh, W - 160 * s, fh, R, `HOY · ${fdate(R.hoyFecha, true).toUpperCase()} · DÍA ${num(R.dias)}`);
    const mid = pickN(R.hist.slice(1, -1), 3), mw = (W - 160 * s - 40 * s) / 3, my = 260 * s + fh * 2;
    mid.forEach((f, i) => foto(ctx, s, f, 80 * s + i * (mw + 20 * s), my, mw, 190 * s, R, fdate(f.fecha).toUpperCase()));
  },

  personal(ctx, W, H, R, P) {
    const s = W / 1240, I = R.iaRes;
    marco(ctx, W, H, R, P, P.kicker, 'Personal en obra');
    const kw = (W - 160 * s - 40 * s) / 3;
    kpi(ctx, s, 80 * s, 210 * s, kw, 170 * s, num(I.prom), 'personas por día (promedio)', R, true);
    kpi(ctx, s, 100 * s + kw, 210 * s, kw, 170 * s, String(I.pico.max), `pico · ${corto(I.pico.fecha)}`, R);
    kpi(ctx, s, 120 * s + kw * 2, 210 * s, kw, 170 * s, String(I.act.length), 'días con actividad', R);
    text(ctx, 'Personas detectadas por día (máximo simultáneo)', 80 * s, 440 * s, { size: 28 * s, color: INK });
    const dd = R.ia.dias.slice(-30);
    barras(ctx, s, 80 * s, 510 * s, W - 160 * s, 380 * s, dd.map((d) => d.max), dd.map((d) => corto(d.fecha)), R.accent, { maxLabels: 15 });
    text(ctx, 'Resumen por semana', 80 * s, 990 * s, { size: 28 * s, color: INK });
    const sem = []; dd.forEach((d, i) => { const k = Math.floor(i / 7); (sem[k] = sem[k] || []).push(d); });
    const cols = [['Semana', 0], ['Promedio', 360], ['Pico', 560], ['Inicio', 720], ['Fin', 900]];
    const y0 = 1050 * s, rh = 62 * s;
    rr(ctx, 80 * s, y0, W - 160 * s, rh, 12 * s); ctx.fillStyle = INK; ctx.fill();
    cols.forEach(([l, x]) => text(ctx, l, 104 * s + x * s, y0 + 17 * s, { size: 22 * s, color: '#fff', weight: 700 }));
    sem.forEach((w, i) => {
      const y = y0 + rh * (i + 1), act = w.filter((d) => d.max > 0);
      if (i % 2) { ctx.fillStyle = '#f5f7f6'; ctx.fillRect(80 * s, y, W - 160 * s, rh); }
      const ini = act.map((d) => d.primera).filter(Boolean).sort()[0] || '-', fin = act.map((d) => d.ultima).filter(Boolean).sort().pop() || '-';
      const vals = [`${corto(w[0].fecha)} al ${corto(w[w.length - 1].fecha)}`, act.length ? num(act.reduce((a, b) => a + b.max, 0) / act.length) : '0', String(Math.max(0, ...w.map((d) => d.max))), ini, fin];
      cols.forEach(([, x], k) => text(ctx, vals[k], 104 * s + x * s, y + 17 * s, { size: 23 * s, color: INK, weight: k ? 500 : 600 }));
    });
    text(ctx, 'Conteo automático de la inteligencia artificial de la cámara Lisual sobre las fotos de la obra.', 80 * s, H - 170 * s, { size: 21 * s, color: MUT, weight: 400, maxW: W - 160 * s });
  },

  seguridad(ctx, W, H, R, P) {
    const s = W / 1240, I = R.iaRes, pct = I.pctCasco ?? 0;
    const est = pct >= 90 ? ['Óptimo', '#1d9a5b'] : pct >= 70 ? ['A mejorar', '#d18b00'] : ['Requiere atención', '#d33a2c'];
    marco(ctx, W, H, R, P, P.kicker, 'Seguridad: uso de casco');
    dona(ctx, s, 300 * s, 440 * s, 170 * s, pct, est[1], 'personas con casco');
    rr(ctx, 560 * s, 330 * s, 360 * s, 70 * s, 35 * s); ctx.fillStyle = est[1]; ctx.fill();
    text(ctx, est[0].toUpperCase(), 740 * s, 348 * s, { size: 28 * s, align: 'center', color: '#fff', weight: 700 });
    text(ctx, 'Porcentaje de personas detectadas con casco sobre el total, en el pico de cada día.', 560 * s, 440 * s, { size: 26 * s, color: MUT, weight: 400, maxW: W - 640 * s, lh: 1.4 });
    const act = R.ia.dias.slice(-30).filter((d) => d.max > 0);
    text(ctx, 'Cumplimiento por día', 80 * s, 720 * s, { size: 28 * s, color: INK });
    barras(ctx, s, 80 * s, 790 * s, W - 160 * s, 380 * s, act.map((d) => Math.round(d.casco / d.max * 100)), act.map((d) => corto(d.fecha)),
      (v) => (v >= 90 ? '#1d9a5b' : v >= 70 ? '#d18b00' : '#d33a2c'), { max: 100, maxLabels: 15 });
    const kw = (W - 160 * s - 20 * s) / 2;
    kpi(ctx, s, 80 * s, 1290 * s, kw, 170 * s, `${act.filter((d) => d.casco / d.max >= 0.9).length} de ${act.length}`, 'días con 90% o más de uso de casco', R);
    kpi(ctx, s, 100 * s + kw, 1290 * s, kw, 170 * s, String(I.diasExc), 'días con excavadoras en obra', R);
  },

  clima(ctx, W, H, R, P) {
    const s = W / 1240, C = R.climaRes;
    marco(ctx, W, H, R, P, P.kicker, 'Clima del último mes');
    const kw = (W - 160 * s - 60 * s) / 4;
    [[Math.round(C.media) + '°', 'temperatura media'], [Math.round(C.max.tmax) + '°', `máxima · ${corto(C.max.fecha)}`], [Math.round(C.min.tmin) + '°', `mínima · ${corto(C.min.fecha)}`], [String(C.diasLluvia), `días de lluvia · ${num(C.mm)} mm`]]
      .forEach(([v, l], i) => kpi(ctx, s, 80 * s + i * (kw + 20 * s), 210 * s, kw, 170 * s, v, l, R, i === 3 && C.diasLluvia > 6));
    // temperaturas (líneas) + lluvia (barras)
    const x = 80 * s, y = 470 * s, w = W - 160 * s, h = 360 * s, d = C.d;
    const tmin = Math.floor(Math.min(...d.map((q) => q.tmin)) - 2), tmax = Math.ceil(Math.max(...d.map((q) => q.tmax)) + 2), mmMax = Math.max(10, ...d.map((q) => q.lluvia));
    text(ctx, 'Temperatura máxima y mínima (°C) y lluvia (mm) por día', x, 420 * s, { size: 26 * s, color: INK });
    ctx.strokeStyle = LINE; ctx.lineWidth = 2 * s;
    for (let k = 0; k <= 4; k++) { const yy = y + h - h * k / 4; ctx.beginPath(); ctx.moveTo(x, yy); ctx.lineTo(x + w, yy); ctx.stroke(); text(ctx, String(Math.round(tmin + (tmax - tmin) * k / 4)) + '°', x - 10 * s, yy - 12 * s, { size: 17 * s, color: MUT, align: 'right', weight: 500 }); }
    const px = (i) => x + w * (i + 0.5) / d.length, py = (t) => y + h - h * (t - tmin) / (tmax - tmin);
    d.forEach((q, i) => { if (q.lluvia > 0) { const bh = h * 0.6 * q.lluvia / mmMax; rr(ctx, px(i) - 7 * s, y + h - bh, 14 * s, bh, 4 * s); ctx.fillStyle = '#7fb3ff'; ctx.fill(); } });
    [['tmax', '#e8682b'], ['tmin', '#3d8bff']].forEach(([k, c]) => {
      ctx.strokeStyle = c; ctx.lineWidth = 5 * s; ctx.beginPath(); d.forEach((q, i) => (i ? ctx.lineTo(px(i), py(q[k])) : ctx.moveTo(px(i), py(q[k])))); ctx.stroke();
      d.forEach((q, i) => dot(ctx, px(i), py(q[k]), 5 * s, c));
    });
    d.forEach((q, i) => { if (i % 5 === 0) text(ctx, corto(q.fecha), px(i), y + h + 12 * s, { size: 17 * s, align: 'center', color: MUT, weight: 500 }); });
    // calendario
    text(ctx, 'Día por día', 80 * s, 940 * s, { size: 26 * s, color: INK });
    const cw = (W - 160 * s - 6 * 14 * s) / 7, ch = 118 * s;
    d.slice(-28).forEach((q, i) => {
      const cx = 80 * s + (i % 7) * (cw + 14 * s), cy = 1000 * s + Math.floor(i / 7) * (ch + 14 * s);
      rr(ctx, cx, cy, cw, ch, 14 * s); ctx.fillStyle = q.lluvia >= 1 ? '#e8f1ff' : CARD; ctx.fill();
      text(ctx, corto(q.fecha), cx + 14 * s, cy + 10 * s, { size: 18 * s, color: MUT, weight: 600 });
      text(ctx, iconoClima(q.code), cx + cw - 14 * s, cy + 6 * s, { size: 30 * s, align: 'right', weight: 400 });
      text(ctx, `${Math.round(q.tmax)}° / ${Math.round(q.tmin)}°`, cx + 14 * s, cy + 50 * s, { size: 22 * s, color: INK, weight: 700 });
      if (q.lluvia >= 1) text(ctx, `💧 ${Math.round(q.lluvia)} mm`, cx + 14 * s, cy + 88 * s, { size: 17 * s, color: '#2b6fd6', weight: 600 });
    });
    text(ctx, C.aprox ? 'Datos de Open-Meteo para Buenos Aires (la obra no tiene ubicación cargada).' : 'Datos meteorológicos de Open-Meteo para la ubicación de la obra.', 80 * s, H - 170 * s, { size: 21 * s, color: MUT, weight: 400, maxW: W - 160 * s });
  },

  reportabilidad(ctx, W, H, R, P) {
    const s = W / 1240, Q = R.repRes;
    marco(ctx, W, H, R, P, P.kicker, 'Reportabilidad de la cámara');
    const kw = (W - 160 * s - 60 * s) / 4;
    [[Q.pct + '%', 'días con registro'], [num(Q.total), 'fotos en 30 días'], [num(Q.prom), 'fotos por día (promedio)'],
      [horaFoto(Q.ultima, R.timeZone), Q.ultima ? `última foto · ${corto(Q.d[Q.d.length - 1].fecha)}` : 'última foto']]
      .forEach(([v, l], i) => kpi(ctx, s, 80 * s + i * (kw + 20 * s), 210 * s, kw, 170 * s, v, l, R, i === 0));
    text(ctx, 'Fotos registradas por día', 80 * s, 440 * s, { size: 28 * s, color: INK });
    barras(ctx, s, 80 * s, 510 * s, W - 160 * s, 420 * s, Q.d.map((d) => d.count), Q.d.map((d) => corto(d.fecha)), (v) => (v > 0 ? R.accent : '#f0b4ad'), { maxLabels: 15, valores: false });
    const msg = Q.pct >= 95 ? 'La cámara funcionó de forma continua durante todo el período.' : Q.pct >= 80 ? 'La cámara registró la gran mayoría de los días. Los días sin fotos suelen coincidir con cortes de energía o de señal en la obra.' : 'Hubo varios días sin registro. Recomendamos revisar la energía y la señal de la cámara con el equipo de Lisual.';
    rr(ctx, 80 * s, 1080 * s, W - 160 * s, 200 * s, 20 * s); ctx.fillStyle = CARD; ctx.fill();
    text(ctx, msg, 120 * s, 1120 * s, { size: 28 * s, color: INK, weight: 500, maxW: W - 240 * s, lh: 1.45 });
    const sin = Q.d.filter((d) => d.count === 0).map((d) => corto(d.fecha));
    text(ctx, sin.length ? `Días sin registro: ${sin.join(', ')}` : 'No hubo días sin registro en el período.', 80 * s, 1330 * s, { size: 24 * s, color: MUT, weight: 500, maxW: W - 160 * s, lh: 1.4 });
    text(ctx, 'La cámara toma una foto cada 10 minutos durante la jornada y la sube automáticamente a la plataforma.', 80 * s, H - 170 * s, { size: 21 * s, color: MUT, weight: 400, maxW: W - 160 * s });
  },

  registro(ctx, W, H, R, P) {
    const s = W / 1240, set = P.fotos;
    marco(ctx, W, H, R, P, P.kicker, P.parte > 1 ? 'Registro fotográfico (cont.)' : 'Registro fotográfico');
    const cw = (W - 160 * s - 30 * s) / 2, chh = 560 * s;
    set.forEach((f, i) => {
      const x = 80 * s + (i % 2) * (cw + 30 * s), y = 210 * s + Math.floor(i / 2) * (chh + 120 * s), fe = f.fecha;
      foto(ctx, s, f, x, y, cw, chh, R, `${f.idx} / ${R.registro.length}`);
      text(ctx, fdate(fe, true), x, y + chh + 18 * s, { size: 26 * s, color: INK, weight: 600 });
      text(ctx, 'Día ' + num(Math.max(1, dias(R.inicio, fe) + 1)), x + cw, y + chh + 20 * s, { size: 24 * s, color: R.accentDark, weight: 700, align: 'right' });
    });
  },

  undia(ctx, W, H, R, P) {
    const s = W / 1240, fr = pickN(R.hoy, 6);
    marco(ctx, W, H, R, P, P.kicker, `Un día en obra · ${fdate(R.hoyFecha, true)}`);
    const cw = (W - 160 * s - 30 * s) / 2, chh = 380 * s;
    fr.forEach((f, i) => {
      const x = 80 * s + (i % 2) * (cw + 30 * s), y = 210 * s + Math.floor(i / 2) * (chh + 70 * s);
      foto(ctx, s, f, x, y, cw, chh, R, f.hora);
    });
    if (!fr.length) text(ctx, 'Todavía no hay fotos de hoy.', 80 * s, 260 * s, { size: 30 * s, color: MUT });
  },

  cierre(ctx, W, H, R, P) {
    const s = W / 1240;
    marco(ctx, W, H, R, P, P.kicker, 'Observaciones y próximos pasos');
    let y = 220 * s;
    String(R.observaciones || '').split(/\n+/).filter(Boolean).forEach((par) => {
      rr(ctx, 80 * s, y, 14 * s, 14 * s, 7 * s); ctx.fillStyle = R.accent; ctx.fill();
      y += text(ctx, par, 116 * s, y - 12 * s, { size: 28 * s, color: INK, weight: 400, maxW: W - 200 * s, lh: 1.45 }) + 26 * s;
    });
    const fy = Math.max(y + 40 * s, H - 820 * s);
    cover(ctx, R.heroItem.src, 0, fy, W, H - 130 * s - fy, 1.05);
    const g = ctx.createLinearGradient(0, fy, 0, H - 130 * s); g.addColorStop(0, 'rgba(7,11,9,.1)'); g.addColorStop(1, 'rgba(7,11,9,.8)'); ctx.fillStyle = g; ctx.fillRect(0, fy, W, H - 130 * s - fy);
    text(ctx, 'Seguí la obra en vivo, todos los días', 80 * s, H - 330 * s, { size: 50 * s, color: '#fff', maxW: W - 160 * s, shadow: 1 });
    text(ctx, 'Desde LisualPro: fotos, timelapse y avance en tiempo real.', 80 * s, H - 240 * s, { size: 28 * s, color: 'rgba(255,255,255,.9)', weight: 500 });
  },
};

export const SECCIONES = [
  { id: 'resumen', nombre: 'Resumen ejecutivo', desc: 'Indicadores clave y texto de situación' },
  { id: 'etapas', nombre: 'Grado de avance', desc: 'Porcentaje por etapa y avance general' },
  { id: 'gantt', nombre: 'Diagrama de Gantt', desc: 'Cronograma con lo planificado y lo ejecutado' },
  { id: 'comparacion', nombre: 'Antes y después', desc: 'Primer día, hoy y tres etapas intermedias' },
  { id: 'personal', nombre: 'Personal en obra', desc: 'Personas por día detectadas por la IA', requires: 'ia' },
  { id: 'seguridad', nombre: 'Seguridad', desc: 'Uso de casco y máquinas en obra', requires: 'ia' },
  { id: 'clima', nombre: 'Clima del mes', desc: 'Temperaturas, lluvia y calendario', requires: 'clima' },
  { id: 'reportabilidad', nombre: 'Reportabilidad', desc: 'Fotos por día y continuidad de la cámara', requires: 'rep' },
  { id: 'registro', nombre: 'Registro fotográfico', desc: 'Fotos de toda la obra, en orden' },
  { id: 'undia', nombre: 'Un día en obra', desc: 'La jornada de hoy, hora por hora' },
  { id: 'cierre', nombre: 'Observaciones', desc: 'Próximos pasos y cierre' },
];

// Arma la lista de páginas según las secciones activas.
export function construirPaginas(R, activas) {
  const pags = [{ id: 'portada' }];
  let n = 0;
  SECCIONES.forEach((sec) => {
    if (!activas[sec.id]) return;
    if (sec.requires === 'ia' && !R.iaRes) return;
    if (sec.requires === 'clima' && !R.climaRes) return;
    if (sec.requires === 'rep' && !R.repRes) return;
    n++;
    const kicker = `${String(n).padStart(2, '0')} · ${sec.nombre}`;
    if (sec.id === 'registro') {
      for (let i = 0, parte = 1; i < R.registro.length; i += 4, parte++) pags.push({ id: 'registro', kicker, fotos: R.registro.slice(i, i + 4), parte });
    } else pags.push({ id: sec.id, kicker });
  });
  return pags.map((p, i) => Object.assign(p, { n: i + 1, total: pags.length }));
}

export function dibujarPagina(canvas, R, P) {
  const ctx = canvas.getContext('2d');
  setEstilo(null);
  ctx.save(); ctx.clearRect(0, 0, canvas.width, canvas.height);
  try { PAGINAS[P.id](ctx, canvas.width, canvas.height, R, P); } catch (e) { /* foto todavía cargando */ }
  ctx.restore();
}

// Prepara los datos del reporte a partir de la obra y lo que eligió el cliente.
export function armarReporte(base, edit) {
  const accent = edit.accent || '#2BE88B';
  const etapas = edit.etapas;
  const R = Object.assign({}, base, {
    accent, accentDark: shadeHex(accent, -0.45), etapas, entrega: edit.entrega,
    titulo: edit.titulo, subtitulo: edit.subtitulo, observaciones: edit.observaciones,
    avance: avanceGeneral(etapas),
  });
  const n = Math.max(4, Number(edit.fotos) || 24);
  R.registro = pickN(base.hist, n).map((f, i) => Object.assign({}, f, { idx: i + 1 }));
  R.resumen = edit.resumen != null ? edit.resumen : redactarResumen(R);
  return R;
}
